<template>
    <Modal :centered="true" v-model:open="open" title="添加解密信息" :footer="null" @cancel="close" :maskClosable="false"
        :width="550">
        <Spin :spinning="spinning">
            <Card>
                <Form :model="formState" name="basic" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" autocomplete="on"
                    @finish="onFinish">
                    <FormItem label="芯片SN" name="name"
                        :rules="[{ required: true, validator: validatePass, trigger: 'change', }]">
                        <Input v-model:value="formState.name" :maxlength="30" :showCount="true" placeholder="请输入加密芯片SN" />
                    </FormItem>
                    <FormItem label="解密密钥" name="details"
                        :rules="[{ required: true, validator: validatePass, trigger: 'change', }]">
                        <Input v-model:value="formState.details" :maxlength="32" :showCount="true"
                            placeholder="请输入解密解密密钥"></Input>
                    </FormItem>
                    <FormItem :wrapperCol="{ offset: 0, span: 24 }">
                        <Button type="primary" html-type="submit" style="width:100%">确定</Button>
                        <Button type="primary" danger @click="close" style="width:100%; margin-top: 10px;">取消</Button>
                    </FormItem>
                </Form>
            </Card>
        </Spin>
    </Modal>
</template>

<script>
import { reactive, toRefs, getCurrentInstance } from 'vue'
import { Modal, Spin, Form, Input, Button, Card, } from "ant-design-vue";
import Que from "./que.js";

export default {
    name: "sesnAdd",
    components: { Modal, Spin, Form, FormItem: Form.Item, Input, Button, Card, },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance();
        const state = reactive({
            open: true,
            spinning: false,
            Que,
        })
        const close = () => {
            emit("close")
        }
        const formState = reactive({
            name: '',
            details: "",
            phone: "",
        });
        const validatePass = (rule, value) => {
            switch (rule.field) {
                case "name":
                    if (value == "") {
                        return Promise.reject("加密芯片SN不能为空")
                    }
                    break;
                case "details":
                    if (value == "") {
                        return Promise.reject("解密密钥不能为空")
                    }
                    if (value.length != 32) {
                        return Promise.reject("解密密钥长度错误")
                    }
                    break;
                default:
                    break;
            }
            return Promise.resolve()
        };
        const onFinish = async (value) => {
            state.spinning = true;
            var result = await Que.post(proxy, value)
            state.spinning = false;
            if (result) {
                close()
            }
        };
        return {
            ...toRefs(state), close, onFinish, formState, validatePass
        }
    }
}
</script>

<style lang="scss" scoped></style>